/*eslint complexity: ["error", 35]*/
import React from 'react';
import { Alert, Button, Col, Row } from 'react-bootstrap';

import { useNavigation } from '../../../common/navigation';
import { GetExamDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { ExaminedEditor } from '../../components/Examined/ExaminedEditor';
import { ExamPreviewLink } from '../../components/Exam/ExamPreviewLink';
import { ExamChatLink } from '../../components/Exam/ExamChatLink';
import { examinedData } from '../../../common/spdCore/contexts/ExaminedContext';

interface ExamExaminedInfoProps {
  exam: GetExamDto | undefined;
  show: boolean;
  handleClickExamined: () => void;
  handleCloseExamined: () => void;
  mode?: string;
}

export const ExamExaminedInfo: React.FC<ExamExaminedInfoProps> = ({
  exam,
  show,
  handleClickExamined,
  handleCloseExamined,
  mode,
}) => {
  const nav = useNavigation();
  const token = localStorage.getItem('mzt-token') || '';

  if (!exam?.examined || !exam?.examined?.id) {
    return null;
  }

  return (
    <Alert variant="success">
      <Row>
        <Col>
          {exam?.online && (
            <>
              <strong>BADANIE ONLINE</strong>
              <br />{' '}
            </>
          )}
          Badany:{' '}
          <strong>
            {exam?.examined?.firstname || ''} {exam?.examined?.surname || ''}
          </strong>{' '}
          {exam?.examined?.pesel
            ? ' PESEL: ' + exam?.examined?.pesel
            : exam?.examined?.iDCardNumber
              ? ' dokument: ' +
                exam?.examined?.iDCardType +
                ' ' +
                exam?.examined?.iDCardNumber
              : ''}
        </Col>
        <Col>
          <div className="d-flex justify-content-end">
            {exam.endDate && <ExamPreviewLink examId={exam.id} dark={true} />}
            {exam.startDate &&
              !exam.endDate &&
              process.env.REACT_APP_CHAT_APP_URL && (
                <ExamChatLink examId={exam.id} token={token} dark={true} />
              )}
            <Button
              variant="outline-dark"
              className="ms-1 mb-1"
              onClick={handleClickExamined}
            >
              Edycja badanego
            </Button>
            <ExaminedEditor
              id={exam?.examined?.id}
              examined={examinedData(exam?.examined)}
              show={show}
              handleClose={handleCloseExamined}
              readOnly={false}
            />
            {!mode && (
              <Button
                variant="outline-dark"
                className="ms-1 mb-1"
                onClick={() => void nav.examsExamined(exam?.examined?.id || '')}
              >
                Badania związane z badanym
              </Button>
            )}
            <Button
              variant="outline-dark"
              className="ms-1 mb-1"
              onClick={() => void nav.attachments(exam?.examined?.id || '')}
            >
              Załączniki badanego
            </Button>
          </div>
        </Col>
      </Row>
    </Alert>
  );
};
